import * as dict from '@/dict'
export default (el, binding) => {
    let { value, modifiers } = binding
    if (!value) {
        return false
    }
    const name = el.getAttribute('name') || undefined
    el.innerHTML = dict.valueToStr(name, value)
}
